import React from "react";
import cx from "classnames";
import { Field } from "formik";
import FormFooter from "forms/components/FormFooter";
import { ShareStatus } from "forms/DealForm";
import PropTypes from "prop-types";
import { spaceShape } from "shapes";

import SubmitButton from "components/SubmitButton";
import Translate from "utils/translate";

import FileField from "../fields/FileField/FileField";

import Deal from "./Deal";
import PortfolioAsset from "./PortfolioAsset";
import ProposalSpaces from "./ProposalSpaces";

import proposalStyles from "./ProposalForm.css";
import styles from "forms/forms.css";

const { t } = new Translate("ProposalForm");

const ProposalForm = (props) => {
  const { defaultUnits, handleSubmit, isAssetDetail, isSubmitting, spaces, values } = props;
  const proposalSpaces = spaces.filter((s) => s.assetId === (values.asset || {}).id);

  return (
    <form className={cx(styles.form, proposalStyles.root)} onSubmit={handleSubmit}>
      <Deal />
      {!isAssetDetail && <PortfolioAsset />}
      <ProposalSpaces defaultUnits={defaultUnits} spaces={proposalSpaces} values={values} />

      <FormFooter>
        <ShareStatus />
        <div className={cx(proposalStyles.upload)}>
          <Field component={FileField} name="file" isButton />
        </div>
        <SubmitButton
          isSubmitting={isSubmitting}
          submitLabel={t("add")}
          submittingLabel={t("adding")}
        />
      </FormFooter>
    </form>
  );
};

ProposalForm.propTypes = {
  defaultUnits: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    sizeUnit: PropTypes.string.isRequired,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isAssetDetail: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  spaces: PropTypes.arrayOf(PropTypes.shape(spaceShape)).isRequired,
  values: PropTypes.shape({
    asset: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
};

export default ProposalForm;
